import { supabase } from './supabase'

async function adminRequest(action, params = {}) {
  const { data, error } = await supabase.functions.invoke('admin', {
    body: { action, ...params }
  })

  if (error) {
    console.error(`[Admin] ${action} error:`, error)
    throw new Error(error.message || 'Admin request failed')
  }

  return data
}

export const getStats = () => adminRequest('stats')
export const getUsers = (search = '') => adminRequest('users', { search })
export const getScans = () => adminRequest('scans')
export const getScanDetail = (id) => adminRequest('scan_detail', { id })
export const deleteScan = (id) => adminRequest('delete_scan', { id })
export const deleteScansBatch = (ids) => adminRequest('delete_scans_batch', { ids })
export const getSettings = () => adminRequest('settings')
export const updateSetting = (key, value) => adminRequest('update_setting', { key, value })
export const triggerCampaign = (type, subject) => adminRequest('campaign', { type, subject })
export const triggerMonthlyReport = () => adminRequest('monthly_report')
